import { render, staticRenderFns } from "./CategoriesSelector.vue?vue&type=template&id=0a5e75a6"
import script from "./CategoriesSelector.vue?vue&type=script&lang=js"
export * from "./CategoriesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports